import React from 'react';

const MaskedEmail = ({ value }) => {

    const maskValue = (value) => {
        
        if (!value) return ""; // Return empty string if value is not provided
        if (value.includes('@')) {
            // Mask email
            const parts = value.split('@');
            const username = parts[0];
            const domain = parts[1];
            const maskedUsername = username.slice(0, 2) + '*'.repeat(username.length - 2);
            const maskedDomain = domain.slice(0, 2) + '**.com';
            return maskedUsername + '@' + maskedDomain;
        } else if (value.match(/^\d+$/)) {
            // Mask mobile number
            return value.slice(0, 2) + '*'.repeat(value.length - 2);
        } else {
            return value;
        }
    };

    return (maskValue(value));
};

export default MaskedEmail;
